import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-furnitureshop-card-step.js';

const stepItem = ({ image, description }) => `
  <article
    class="furnitureshop-card-step__item"
    data-attribute="furnitureshop-card-step__item"
  >
    <img
      class="furnitureshop-card-step__item-image"
      data-attribute="furnitureshop-card-step__item-image"
      src="${image}"
      alt=""
    />
    <div
      class="furnitureshop-card-step__item-description"
      data-attribute="furnitureshop-card-step__item-description"
    >
      ${description}
    </div>
  </article>
`;

const contentHtml = `
  <div
    class="furnitureshop-card-step container"
    data-attribute="furnitureshop-card-step"
  >
    <header
      class="furnitureshop-card-step__header"
      data-attribute="furnitureshop-card-step__header"
    >
      <div
        class="furnitureshop-card-step__title"
        data-attribute="furnitureshop-card-step__title"
      >
        <h2>
          <span style="font-size: 40px"><strong>Mirror Finish,</strong></span
          ><br /><span style="font-size: 40px"
            ><strong>Instantly Visible</strong></span
          >
        </h2>
      </div>
      <div
        class="furnitureshop-card-step__heading"
        data-attribute="furnitureshop-card-step__heading"
      >
        <img
            class="furnitureshop-card-step__decor"
            data-attribute="furnitureshop-card-step__decor"
            src="https://cdn.skyfastimg.com/images/2026/08/20/image-6a86740aab3a65f2691e0790.png?w=500"
            alt=""
          />
        <div
          class="furnitureshop-card-step__description"
          data-attribute="furnitureshop-card-step__description"
        >
          <p>
            Fills micro-imperfections in the clear coat<br />to create a flawless,
            mirror-smooth surface.
          </p>
        </div>
      </div>
    </header>
    <div
      class="furnitureshop-card-step__content"
      data-attribute="furnitureshop-card-step__content"
    >
      <div
        class="furnitureshop-card-step__media"
        data-attribute="furnitureshop-card-step__media"
        data-show="true"
        data-position="left"
        data-media-type="video"
      >
        <video
          class="furnitureshop-card-step__video"
          data-attribute="furnitureshop-card-step__video"
          autoplay
          muted
          loop
          playsinline
        >
          <source
            data-attribute="furnitureshop-card-step__video-source"
            src="https://cdn.shopify.com/videos/c/vp/d495fb86643f421d95852007c02b22d3/d495fb86643f421d95852007c02b22d3.SD-480p-1.5Mbps-80633362.mp4"
            type="video/mp4"
          />
        </video>
        <div class="furnitureshop-card-step__media-image" data-attribute="furnitureshop-card-step__media-image" style="display: none">
          <img data-attribute="furnitureshop-card-step__media-image-inner" src="" alt="" />
        </div>
      </div>
      <div
        class="furnitureshop-card-step__steps"
        data-attribute="furnitureshop-card-step__steps"
      >
        ${stepItem({
          image: 'https://cdn.skyfastimg.com/images/2026/08/20/image-6a86742b4fd03c8374fd33c3.webp?w=1000',
          description: `
            <h3 style="text-align: center">PREP&nbsp;</h3>
            <p style="text-align: center">Add drops to sponge</p>
            <p style="text-align: center">&nbsp;</p>
            <h2 style="text-align: center">
              <span style="color:hsl( 32, 100%, 54% )"><strong>99%</strong></span>
            </h2>
            <p style="text-align: center">Surface Safety</p>
          `,
        })}
        ${stepItem({
          image: 'https://cdn.skyfastimg.com/images/2026/08/20/image-6a867441b0ed0415dd212855.webp?w=1000',
          description: `
            <h3 style="text-align: center">SPREAD&nbsp;</h3>
            <p style="text-align: center">Apply in cross-hatch</p>
            <p style="text-align: center">&nbsp;</p>
            <h2 style="text-align: center">
              <span style="color:hsl( 32, 100%, 54% )"><strong>100%</strong></span>
            </h2>
            <p style="text-align: center">Brilliant Shine</p>
          `,
        })}
        ${stepItem({
          image: 'https://cdn.skyfastimg.com/images/2026/08/20/image-6a867460edc2743bfb9a634d.webp?w=1000',
          description: `
            <h3 style="text-align: center">BUFF&nbsp;</h3>
            <p style="text-align: center">Wait, then wipe gently</p>
            <p style="text-align: center">&nbsp;</p>
            <h2 style="text-align: center">
              <span style="color:hsl( 32, 100%, 54% )"><strong>180-Day</strong></span>
            </h2>
            <p style="text-align: center">Lasting Shield</p>
          `,
        })}
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#2A2A2A',
  textColor: '#FFFFFF',
});
